module.exports = __webpack_public_path__ + "img/climate_contribution_with_ConClimate-Logo.b56d682a.png";